import { Box } from '@mui/material';
import { DataCellProps } from '../types';
import { formatApproval, REALM_ARCHIVED_LABEL } from '../helpers';

export const DataDeletionDeveloperApprovalCell = ({ team }: DataCellProps) => {
  return (
    <Box>
      {team.realmArchived
        ? REALM_ARCHIVED_LABEL
        : formatApproval(team.developerApproved, team.developerApprover, team.developerApprovedAt)}
    </Box>
  );
};
